// // import Head from "next/head";
// // import { useRouter } from "next/router";

// // const SITE_URL = "https://www.prism-me.com";

// // export default function HreflangLinks({ enPath, arPath }) {
// //   const router = useRouter();

// //   const currentPath = (router.asPath || "/").split("?")[0];

// //   const cleanPath = (p) => {
// //     if (!p) return "/";
// //     return p.startsWith("/") ? p : `/${p}`;
// //   };

// //   const basePath = cleanPath(
// //     enPath ?? currentPath.replace(/^\/ar(?=\/|$)/, ""),
// //   );
// //   const en = `${SITE_URL}${basePath}`;
// //   const ar = `${SITE_URL}/ar${basePath === "/" ? "" : basePath}`;

// //   return (
// //     <Head>
// //       {enPath && <link rel="alternate" href={en} hreflang="en" />}
// //       {arPath && <link rel="alternate" href={ar} hreflang="ar" />}
// //       <link rel="alternate" href={en} hreflang="x-default" />
// //     </Head>
// //   );
// // }

// import Head from "next/head";
// import { useRouter } from "next/router";

// const SITE_URL = "https://www.prism-me.com";

// export default function HreflangLinks({ enPath, arPath, params = {} }) {
//   const router = useRouter();

//   const currentPath = (router.asPath || "/").split("?")[0];

//   const cleanPath = (p) => {
//     if (!p) return "/";
//     return p.startsWith("/") ? p : `/${p}`;
//   };

//   const basePath = cleanPath(
//     enPath ?? currentPath.replace(/^\/ar(?=\/|$)/, ""),
//   );

//   // Build query string
//   const searchParams = new URLSearchParams();

//   Object.entries(params).forEach(([key, value]) => {
//     if (value !== undefined && value !== null && value !== "") {
//       searchParams.set(key, value);
//     }
//   });

//   const queryString = searchParams.toString();
//   const suffix = queryString ? `?${queryString}` : "";

//   const en = `${SITE_URL}${basePath}${suffix}`;
//   const ar = `${SITE_URL}/ar${basePath === "/" ? "" : basePath}${suffix}`;

//   return (
//     <Head>
//       {enPath && <link rel="alternate" href={en} hrefLang="en" />}
//       {arPath && <link rel="alternate" href={ar} hrefLang="ar" />}
//       <link rel="alternate" href={en} hrefLang="x-default" />
//     </Head>
//   );
// }
import Head from "next/head";

const SITE_URL = "https://www.prism-me.com";

function buildUrl(path, params = {}) {
  if (!path) return null;
  const clean = path.startsWith("/") ? path : `/${path}`;

  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.set(key, value);
    }
  });
  const qs = searchParams.toString();
  return `${SITE_URL}${clean}${qs ? `?${qs}` : ""}`;
}

/**
 * enPath / arPath = the REAL final path for that locale, already
 * including "/ar" for Arabic. Pass null/undefined for a locale that
 * doesn't exist for this content (e.g. no Arabic translation yet) —
 * that locale's tag is simply omitted, never faked.
 *
 * params = shared query params (e.g. { cat, page }) applied
 * identically to both URLs so canonical and hreflang can never drift.
 */
export default function HreflangLinks({
  enPath,
  arPath,
  params = {},
  defaultLocale = "en",
}) {
  const en = buildUrl(enPath, params);
  const ar = buildUrl(arPath, params);
  const xDefault = defaultLocale === "ar" ? ar : en;

  if (!en && !ar) return null;

  return (
    <Head>
      {en && <link rel="alternate" href={en} hrefLang="en" />}
      {ar && <link rel="alternate" href={ar} hrefLang="ar" />}
      {xDefault && (
        <link rel="alternate" href={xDefault} hrefLang="x-default" />
      )}
    </Head>
  );
}
